import RasterModel from "./raster";
import RasterRgbModel from "./rasterRgb";
import RasterTerrainRGB from "./rasterTerrainRgb";
const RasterModels = {
  raster: RasterModel,
  rasterRgb: RasterRgbModel,
  raster3d: RasterModel,
  rasterTerrainRgb: RasterTerrainRGB
};
export default RasterModels;